import React from 'react';
import { Formik } from 'formik';

import FormWrapper from '~FormWrapper';
import ICTLinksForm from './ICTLinksForm';

import { useOnSubmit } from '~hooks/useOnSubmit';

const ICTLinks = props => {
  const { formId } = props;

  // const organizations = useSelector(state => state.reducer.organizations);

  const onFormSubmit = useOnSubmit();

  return (
    <Formik
      initialValues={{}}
      onSubmit={async (values, { setSubmitting }) => {
        setSubmitting(true);
        await onFormSubmit({
          fields: {
            ...values,
          },
          setSubmitting,
          formId,
        });
      }}
    >
      {formikProps => (
        <FormWrapper
          {...props}
          title="Puhelin- ja liittymätilaukset"
          hideButtons
          formik={formikProps}
          Component={ICTLinksForm}
        />
      )}
    </Formik>
  );
};

export default ICTLinks;
